<template>
  <!-- :is 可根據傳入參數的不同，而去切換不同的元件 -->
  <component :is="resolveLayout">
    <router-view></router-view>
    <loading-dialog :load="initLoading" />
    <snack :type="alertType" :text="alertText" :show="showAlert" :closeManual="closeManual"/>
    <alert-dialog />
    <confirm-leave-dialog />
  </component>
</template>

<script>
import { computed } from '@vue/composition-api'
import { useRouter } from '@/utils'
import LayoutBlank from '@/views/layouts/Blank.vue'
import LayoutContent from '@/views/layouts/Content.vue'
import LoadingDialog from '@/components/layout/LoadingDialog'
import Snack from '@/components/Snack'
import AlertDialog from '@/components/AlertDialog.vue'
import ConfirmLeaveDialog from '@/components/ConfirmLeaveDialog.vue'

export default {
  components: {
    LayoutBlank,
    LayoutContent,
    LoadingDialog,
    Snack,
    AlertDialog,
    ConfirmLeaveDialog
  },
  setup() {
    const { route } = useRouter()

    const resolveLayout = computed(() => {
      // https://vuejs.org/v2/guide/computed.html#Computed-Properties
      // Handles initial route
      if (route.value.name === null) return null

      if (route.value.meta.layout === 'blank') return 'layout-blank'

      return 'layout-content'
    })

    return {
      resolveLayout,
    }
  },
  computed: {
    initLoading() {
      return this.$store.getters.initLoading
    },
    alertType() {
      return this.$store.getters.alertMessage.type
    },
    alertText() {
      return this.$store.getters.alertMessage.message
    },
    closeManual() {
      return this.$store.getters.alertMessage.closeManual
    },
    showAlert() {
      return this.$store.getters.alertMessage.show
    }
  },
}
</script>
